(function () {
  function getThreshold() {
    const bar = document.querySelector('[data-free-shipping-bar]');
    return bar ? parseInt(bar.dataset.threshold, 10) : 59900;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' kr';
  }

  function render(total) {
    const bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    const threshold = getThreshold();
    const remaining = threshold - total;
    let percent = Math.round((total / threshold) * 100);
    if (percent > 100) percent = 100;

    let text;
    if (total === 0) {
      text = 'Fri fragt ved køb over ' + formatMoney(threshold) + '!';
    } else if (remaining > 0) {
      text = 'Du er ' + formatMoney(remaining) + ' fra gratis fragt!';
    } else {
      text = 'Tillykke! Du har opnået fri fragt!';
    }

    bars.forEach(bar => {
      const t = bar.querySelector('[data-fsb-text]');
      const f = bar.querySelector('[data-fsb-fill]');
      if (t) t.textContent = text;
      if (f) f.style.width = percent + '%';
    });
  }

  async function refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      render(cart.total_price);
    } catch (e) {
      // Stilhed – baren beholder sin nuværende visning
    }
  }

  const origFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];
    const path = typeof url === 'string' ? url : (url && url.url) || '';
    const promise = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(path)) {
      promise.then(() => setTimeout(refresh, 120));
    }
    return promise;
  };

  document.addEventListener('DOMContentLoaded', refresh);
})();